module.exports = __webpack_public_path__ + "media/images/pc/specials/common/event_detail_photo_experience-ccb6f11bcba3f3bef1139fc5f213b77b.jpg";